// src/features/api.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../redux/baseQuery";

interface CreateWithdrawalResponse {
  data: { message?: string; success: boolean };
}

interface Withdrawals {
  amount: number;
  config: {
    amountType: string;
    frequency: string;
    payday: string;
  };
  account: any;
}

export const createUserAutomaticDrawal = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["Withdrawals"],
  endpoints: (builder) => ({
    getWithdrawals: builder.query<CreateWithdrawalResponse[], void>({
      query: () => "automatic-withdrawal/search",
      providesTags: ["Withdrawals"],
    }),

    createWithdrawal: builder.mutation<CreateWithdrawalResponse, Withdrawals>({
      query: (body) => ({
        url: "automatic-withdrawal/create",
        method: "POST",
        body,
        invalidatesTags: ["Withdrawals"],
      }),
    }),
  }),
});

export const { useCreateWithdrawalMutation, useGetWithdrawalsQuery } =
  createUserAutomaticDrawal;
